<template>
  <div class="c-keyboard" v-visible="!loading">
    <img
      v-show="noLED"
      class="background"
      :src="images.keyboard_80_no_led"
      @load="onLoad"
    />
    <img
      v-show="!noLED"
      class="background"
      :src="images.keyboard_80"
      @load="onLoad"
    />
    <div class="keys">
      <c-key
        v-for="(srcKey, index) in finalSrcKeys"
        class="key"
        :class="{
          selected: selectedIndex === index,
          changed: !disabled && false,
          disabled: srcKey.disabled,
        }"
        :key="'srcKey' + index"
        :style="srcKey.style"
        :selected="selectedIndex === index"
        :profile="profile80"
        :layer="layer"
        :allKeys="allKeys"
        :dstKeys="dstKeys"
        :srcKey="srcKey"
        @click="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
        @dblclick="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { srcKeys, dstKeys } from "./Keyboard80";
import { allKeys } from "./VirtualKeyboard80";
import { deepCopy } from "@/utils";

export default {
  name: "CKeyboard80",
  props: {
    disabled: Boolean,
    selectedIndex: Number,
    layer: Array,
    layerIndex: Number,
  },
  data() {
    return {
      loading: true,
      noLEDSrcKeys: deepCopy(srcKeys),
      srcKeys: deepCopy(srcKeys),
      dstKeys: deepCopy(dstKeys),
      allKeys,
    };
  },
  computed: {
    ...mapState(["profile80"]),
    ...mapState("profile80", {
      noLED: "noLED",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    finalSrcKeys() {
      return this.noLED ? this.noLEDSrcKeys : this.srcKeys;
    },
  },
  watch: {
    layerIndex(layerIndex) {
      if (layerIndex === 1) {
        this.srcKeys[0] = {
          ...srcKeys[0],
          disabled: true,
        };
        this.noLEDSrcKeys[0] = {
          ...srcKeys[0],
          disabled: true,
        };
        // this.srcKeys[20] = {
        //   ...srcKeys[20],
        //   disabled: true,
        // };
      } else {
        this.srcKeys[0] = { ...srcKeys[0] };
        this.noLEDSrcKeys[0] = { ...srcKeys[0] };
        // this.srcKeys[20] = { ...srcKeys[20] };
      }
    },
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
  },
  mounted() {
    // this.noLEDSrcKeys.splice(30, 1);
    // this.noLEDSrcKeys.splice(46, 1);
    // this.noLEDSrcKeys.splice(49, 1);
    // this.noLEDSrcKeys.splice(60, 1);
    // this.noLEDSrcKeys.splice(60, 1);
    this.noLEDSrcKeys = [
      ...this.noLEDSrcKeys,
      { index: 75, style: { top: "52.7%", left: "-15%", width: "7.5%" } },
      { index: 100, style: { top: "69%", left: "-17.9%", width: "4.8%" } },
      { index: 129, style: { top: "69%", left: "-11%" } },

      { index: 130, style: { top: "20.5%", left: "106.9%" } },
      { index: 38, style: { top: "20.5%", left: "112.5%" } },
      {
        index: 87,
        style: {
          top: "36.3%",
          left: "111%",
          width: "6.4%",
          height: "28.4%",
          paddingBottom: "5%",
        },
      },
      { index: 134, style: { top: "52.7%", left: "106.9%" } },
    ];
  },
};
</script>
<style lang="scss" scoped>
.c-keyboard {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .keys {
    width: 73.2%;
    height: 79.3%;
    position: absolute;
    left: 13.6%;
    top: 11.5%;
    display: flex;
    flex-wrap: wrap;

    .key {
      width: 3.6%;
      height: 12.5%;
      padding: 0 0.2%;
      font-size: 20px;
    }
  }
}
</style>
